import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import { BtnConfig } from '../../../model';

/**
 * * Componente de um grupo de botões.
 */
@Component({
  selector: 'ui-btn-group',
  templateUrl: './btn-group.component.html',
  styleUrls: ['./btn-group.component.scss']
})
export class BtnGroupComponent implements OnInit {


  /**
   * * Configuração do grupo de botões (array).
   */
  @Input() btns: BtnConfig[] = [];

  /**
   * * Evento do clique do botão (retornando o id do botão clicado).
   */
  @Output() emitter = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public emit(id: string) {
    this.emitter.emit(id);
  }

}
